import styled from 'styled-components';

export const IconButton = ({
  onClick,
  iconClassName,
  iconSize,
  isActive,
  isDisabled,
  isDimmed,

  label,
  styleType,
  style,
}: {
  onClick?: () => void;
  iconClassName: string;
  iconSize?: number;
  isActive?: boolean;
  isDisabled?: boolean;
  isDimmed?: boolean;

  label?: string;
  styleType?: 'primary';
  style?: React.CSSProperties;
}) => {
  return (
    <Container
      $isActive={isActive}
      $isDisabled={isDisabled}
      $isDimmed={isDimmed}
      $styleType={styleType}
      onClick={onClick}
      style={style}
    >
      <i
        className={iconClassName}
        style={{ fontSize: iconSize ? `${iconSize}px` : '22px', lineHeight: iconSize ? `${iconSize}px` : '22px' }}
      />
      {label && <Label>{label}</Label>}
    </Container>
  );
};

const Label = styled.span`
  pointer-events: none;
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;

  display: flex;
  justify-content: center;

  font-size: 9px;

  opacity: 0;
`;

const Container = styled.div<{
  $isActive?: boolean;
  $isDisabled?: boolean;
  $isDimmed?: boolean;
  $styleType?: 'primary';
}>`
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  user-select: none;
  padding: 3px 3px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--neutral-2);
  color: var(--main-2);
  border-radius: var(--radius-2);
  ${({ $styleType }) =>
    $styleType === 'primary' &&
    `
    border: 1px solid var(--neutral-3);
  `}

  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    opacity 0.3s ease;

  ${({ $isActive }) =>
    !$isActive &&
    `
    &:hover {
      background-color: var(--neutral-3);
      color: var(--main-1);

      > ${Label} {
        opacity: 1;
      }
    }
  `}

  ${({ $isActive, $styleType }) =>
    $isActive &&
    `
    > ${Label} {
      opacity: 1;
    }
    
    background-color: var(--neutral-3);
    color: var(--main-1);
    ${$styleType === 'primary' && `border: 1px solid var(--primary-1); color: var(--primary-1);`}
  `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}

  ${({ $isDimmed }) =>
    $isDimmed &&
    `
    opacity: 0.5;
  `}
`;
